module.exports = __webpack_public_path__ + "static/img/0000智慧校园.4d06284.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000智慧校园.jpg
// module id = 0fXw
// module chunks = 0